export default {
  name: 'uploadimg',
  icon: './lib/UEditor/button-icon/d2admin.png',
  tip: '上传图片',
  handler: function handler(editor, name) {
    // document.getElementById("fileElem").click();
    // document.getElementById('fileElem').addEventListener('change', function (event) {
    //   var $file = event.currentTarget;
    //   var formData = new FormData();
    //   var file = $file.files;
    //   for (var i = 0; i < file.length; i++) {
    //     // 文件名称，文件对象
    //     formData = new FormData();
    //     formData.append(file[i].name, file[i]);
    //     $.ajax({
    //       url: '/upload',
    //       type: 'POST',
    //       dataType: 'json',
    //       data: formData,
    //       contentType: false,
    //       processData: false
    //     })
    //       .done(data => {
    //         $('#box').append(`<div class="photo-item">
    //             <img class="item-image" width="100%" height="100%" src="${data.url}"/>
    //         </div>`);
    //       })
    //       .fail(data => {
    //         console.log(data);
    //       });
    //   }
    // })
    editor.execCommand('inserthtml', "<p><img src=\"https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1586522202657&di=d63439ba047e067c68cb2b10488281c5&imgtype=0&src=http%3A%2F%2Fa4.att.hudong.com%2F63%2F89%2F01300000921826141395899299273.jpg\"/></p>");
  }
};